import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon ,MDBRow, MDBCol,MDBDataTable ,MDBTabPane ,MDBNav,MDBTabContent,
  MDBNavItem,
  MDBNavLink } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Superadminlistregistertypeshow from './Superadminlistregistertypeshow';


export default class superadminlistregister extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            registertype:[],
            activeItem: "1",
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.toggle = this.toggle.bind(this);
      }

      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({
            activeItem: tab
          });
        }
      };


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selectregistertype')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ registertype: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {



      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'register_pname',
            sort: 'register_pname',
            width: 150
          },
          {
            label: 'เบอร์โทร',
            field: 'register_phone',
            sort: 'register_phone',
            width: 150
          },
          {
            label: 'อีเมลล์',
            field: 'register_email',
            sort: 'register_email',
            width: 150
          },
      
        
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
      
          {
     
  
             list: <>{i+1}</>,
             register_pname: <>{data.register_pname}{data.register_nameth} {data.register_lnameth}</>,
             register_phone: <>{data.register_phone}</>,
             register_email: <>{data.register_email}</>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ-นามสกุล"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />



        return (
            <MDBContainer fluid>
            <div>
             {localStorage.getItem('nameuser') === 'admindype1' ?<>
              <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} ผู้ดูแลระบบประเภท {localStorage.getItem('presentype_name')}</p>
             </>:<>
              <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
             </>}
           
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
            <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}
               
                 
                   
                    
                       <MDBRow >
                    <MDBCol md="8">
                    <PageHeader
                        className="site-page-header"
                       // onBack={() => null}
                        title="ข้อมูลลงทะเบียน"
                        subTitle="ข้อมูลลงทะเบียน"
                        avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/3456/3456388.png' }}
                    />
                    </MDBCol>
                    <MDBCol md="4">
                      {/* <p> hjkjk</p>  */}
                    </MDBCol>
                    </MDBRow>
                  
   </MDBAlert>
   <p className='font-weight-bold'>ผู้ลงทะเบียนทั้งหมด แต่ละประเภท</p>

      <MDBNav className="nav-tabs mt-2">
           {this.state.registertype.map((presentationtype,index )  => 
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === presentationtype.id_typeregister	} onClick={this.toggle(presentationtype.id_typeregister	)} role="tab" >
              {presentationtype.name_typeregister	}
            </MDBNavLink>
          </MDBNavItem>
           )}

      </MDBNav>

      <MDBTabContent activeItem={this.state.activeItem} >
        {this.state.registertype.map((presentationtype,index )  => 
          <MDBTabPane tabId={presentationtype.id_typeregister} role="tabpanel">
            {/* <p className="mt-2">
          
            </p> */}
            <Superadminlistregistertypeshow id_typeregister={presentationtype.id_typeregister} name_typeregister={presentationtype.name_typeregister}/>
          {/* <Superadminlistarticalgroup id_typeregister={presentationtype.id_typeregister} presentype_name={presentationtype.presentype_name} /> */}
          </MDBTabPane>
         )}

        
        </MDBTabContent>


                {/* <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th>เบอร์โทร</th>
                        <th>อีเมลล์</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.register_pname}{article.register_nameth} {article.register_lnameth}</td>
                        <td>{article.register_phone}</td>
                        <td>{article.register_email}</td>
                       
                        
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}
                   {/* {persons}  */}

            </div>
            </MDBContainer>
        )
    }
}
